import AnonymousProfile from "@/components/shared/AnonymousCompanyProfile/AnonymousProfile";

export default function InterestPage() {
  return <AnonymousProfile pageID="INTEREST" />;
}
